import {
    IonLabel,
    IonRow,
    IonSegment,
    IonSegmentButton,
    SegmentChangeEventDetail,
} from '@ionic/react';
import { Trans } from '@lingui/macro';
import React, { useCallback } from 'react';

interface YesNoProps {
    label: string;
    value?: boolean;
    onChange: (val: boolean) => void;
}
const YesNo: React.FunctionComponent<YesNoProps> = ({
    label,
    value,
    onChange,
}) => {
    const onChangeHandler = useCallback(
        (e: CustomEvent<SegmentChangeEventDetail>) => {
            onChange(e.detail.value === 'yes');
        },
        [onChange]
    );

    return (
        <>
            <IonRow className="ion-margin-bottom">
                <IonLabel>{label}</IonLabel>
            </IonRow>
            <IonSegment
                value={
                    value === true ? 'yes' : value === false ? 'no' : undefined
                }
                onIonChange={onChangeHandler}
            >
                <IonSegmentButton
                    value="yes"
                    className="ion-justify-content-between ion-align-items-center"
                >
                    <IonLabel style={{ textTransform: 'uppercase' }}>
                        <Trans>Yes</Trans>
                    </IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="no">
                    <IonLabel style={{ textTransform: 'uppercase' }}>
                        <Trans>No</Trans>
                    </IonLabel>
                </IonSegmentButton>
            </IonSegment>
            <div className="ion-margin-bottom" />
        </>
    );
};

export default YesNo;
